import type {DistrictKey} from "@/composables/functions/getDistrictName";
import type {RegionKey} from "@/composables/functions/getRegionName";

export const regionToDistrictList: Record<RegionKey, DistrictKey> = {
    "adygea": "southern",
    "altai_republic": "siberian",
    "altai_krai": "siberian",
    "amur": "far_eastern",
    "arkhangelsk": "northwestern",
    "astrakhan": "southern",
    "bashkortostan": "volga",
    "belgorod": "central",
    "bryansk": "central",
    "buryatia": "far_eastern",
    "chechen": "north_caucasian",
    "chelyabinsk": "ural",
    "chukotka": "far_eastern",
    "chuvashia": "volga",
    "dagestan": "north_caucasian",
    "jewish_ao": "far_eastern",
    "yamalo_nenets": "ural",
    "yaroslavl": "central",
    "ingushetia": "north_caucasian",
    "irkutsk": "siberian",
    "ivanovo": "central",
    "kabardino_balkaria": "north_caucasian",
    "kaliningrad": "northwestern",
    "kalmykia": "southern",
    "kaluga": "central",
    "kamchatka": "far_eastern",
    "karachay_cherkessia": "north_caucasian",
    "karelia": "northwestern",
    "kemerovo": "siberian",
    "kirov": "volga",
    "komi": "northwestern",
    "kostroma": "central",
    "krasnodar": "southern",
    "krasnoyarsk": "siberian",
    "crimea": "southern",
    "kurgan": "ural",
    "kursk": "central",
    "lipetsk": "central",
    "magadan": "far_eastern",
    "mari_el": "volga",
    "mordovia": "volga",
    "moscow_oblast": "central",
    "moscow_city": "central",
    "murmansk": "northwestern",
    "nenets": "northwestern",
    "nizhny_novgorod": "volga",
    "novgorod": "northwestern",
    "novosibirsk": "siberian",
    "omsk": "siberian",
    "orel": "central",
    "orenburg": "volga",
    "north_ossetia": "north_caucasian",
    "penza": "volga",
    "perm": "volga",
    "primorsky": "far_eastern",
    "pskov": "northwestern",
    "ryazan": "central",
    "rostov": "southern",
    "samara": "volga",
    "st_petersburg": "northwestern",
    "saratov": "volga",
    "sakha": "far_eastern",
    "sakhalin": "far_eastern",
    "sevastopol": "southern",
    "sirius": "southern",
    "north_caucasus": "north_caucasian",
    "smolensk": "central",
    "stavropol": "north_caucasian",
    "sverdlovsk": "ural",
    "tambov": "central",
    "tatarstan": "volga",
    "tomsk": "siberian",
    "tyumen": "ural",
    "tver": "central",
    "tula": "central",
    "tuva": "siberian",
    "vladimir": "central",
    "volgograd": "southern",
    "vologda": "northwestern",
    "voronezh": "central",
    "khabarovsk": "far_eastern",
    "khakassia": "siberian",
    "khanty_mansi": "ural",
    "udmurtia": "volga",
    "ulyanovsk": "volga",
    "zabaykalsky": "far_eastern"
};